export const DEFAULT_HEARTBEAT_MAX_AGE_MS = 10 * 60 * 1000;

export const HEARTBEAT_MAX_AGE_MS_BY_SOURCE_TYPE = {
    sensor: 10 * 60 * 1000,
    phonebox: 30 * 60 * 1000,
    machine_learning: 24 * 60 * 60 * 1000,
    sgre_forecast: 24 * 60 * 60 * 1000,
    dmi_forecast: 12 * 60 * 60 * 1000,
    dmi_observation: 3 * 60 * 60 * 1000,
    open_meteo: 12 * 60 * 60 * 1000,
    watchdog: 5 * 60 * 1000,
};

export function getHeartbeatMaxAgeMs(sourceType) {
    return HEARTBEAT_MAX_AGE_MS_BY_SOURCE_TYPE[sourceType] ?? DEFAULT_HEARTBEAT_MAX_AGE_MS;
}
